import { useEffect, useState } from 'react';
import { useWorkContext } from '../context/WorkContext';
import Make from './../components/MakeSection/Make';
import RelatedServices from '../components/RelatedServicesSection/RelatedServices';
import Focus from '../components/FocusServices/Focus';
import FAQs from '../components/FAQsSection/FAQs';
import IssueSection from '../components/IssuesSection/Issue';
import LatestArticles from '../components/LatestArticles/LatestArticles';
import ProjectItem from '../components/WorkProjectsList/ProjectItem/ProjectItem';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const BrandIdentity = () => {
    const { getRandomProject } = useWorkContext();
    const [randomProject, setRandomProject] = useState(null);
    const seo = usePageSEO('brandIdentity');

    useEffect(() => {
        const project = getRandomProject();
        setRandomProject(project);
    }, [getRandomProject]);

    const selectedServiceIds = [2, 3, 5, 8];

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <HeroSection page="BrandingPage" showRecentWork={false} showMoreButton={true} />
            <IssueSection page="BrandIdentityPage" skeletonItemsCount={3} subCountSkeleton={1} />
            <Focus page="BrandIdentityPage"/>
            <FAQs page='brandingPage' />
            <RelatedServices services={selectedServiceIds} />
            <LatestArticles />
            <ProjectItem project={randomProject} index={0} />
            <Make pageKey="brandIdentityPage" />
        </>
    );
};

export default BrandIdentity;